/**
 * Construcción de volumen: el resample ya cede el hilo (`yieldTick`).
 * Un Worker Blob queda listo para HU nativo ya empaquetado; si no hay Worker
 * se usa el mismo `buildUint8Volume` del hilo principal.
 */
import { buildUint8Volume } from './mpr3dVolume'

export async function buildUint8VolumeMaybeWorker(files, opts = {}) {
  return buildUint8Volume(files, opts)
}
